/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPresentationOptions } from './FxIdDomainSettingsPresentationOptions';
import {
    instanceOfFxIdDomainSettingsPresentationOptions,
    FxIdDomainSettingsPresentationOptionsFromJSON,
    FxIdDomainSettingsPresentationOptionsFromJSONTyped,
    FxIdDomainSettingsPresentationOptionsToJSON,
} from './FxIdDomainSettingsPresentationOptions';

/**
 * @type FxGamesLibWebPublicDataBasePresentation
 * 
 * @export
 */
export type FxGamesLibWebPublicDataBasePresentation = FxIdDomainSettingsPresentationOptions;

export function FxGamesLibWebPublicDataBasePresentationFromJSON(json: any): FxGamesLibWebPublicDataBasePresentation {
    return FxGamesLibWebPublicDataBasePresentationFromJSONTyped(json, false);
}

export function FxGamesLibWebPublicDataBasePresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPublicDataBasePresentation {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPresentationOptions(json)) {
        return FxIdDomainSettingsPresentationOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxGamesLibWebPublicDataBasePresentationToJSON(json: any): any {
    return FxGamesLibWebPublicDataBasePresentationToJSONTyped(json, false);
}

export function FxGamesLibWebPublicDataBasePresentationToJSONTyped(value?: FxGamesLibWebPublicDataBasePresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPresentationOptions(value)) {
        return FxIdDomainSettingsPresentationOptionsToJSON(value as FxIdDomainSettingsPresentationOptions);
    }

    return {};
}

